import { render, staticRenderFns } from "./templates.view.component.vue?vue&type=template&id=2e3142d9&scoped=true&"
import script from "./templates.view.component.vue?vue&type=script&lang=ts&"
export * from "./templates.view.component.vue?vue&type=script&lang=ts&"
import style0 from "./templates.view.component.vue?vue&type=style&index=0&id=2e3142d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3142d9",
  null
  
)

export default component.exports